



























































// Vue
import Vue from "vue";
// Vuelidate
import { validationMixin } from "vuelidate";
import { UpdateJobSiteModel, LocationType } from "@/core/api/apiClient";

export default Vue.extend({
  name: "CreateJobsiteDialog",
  mixins: [validationMixin],

  data() {
    return {
      dialog: false,

      name: "",
      streetAddress: "",
      city: "",
      notes: ""
    };
  },

  methods: {
    submit(): void {
      if (!this.checkValid()) return;

      // Default the Jobsite Name to it's StreetAddress if no Name is provided
      if (!this.name) this.name = this.streetAddress;

      const newJobSite: UpdateJobSiteModel = new UpdateJobSiteModel({
        name: this.name,
        streetAddress: this.streetAddress,
        cityAddress: this.city,
        locationType: LocationType.Address,
        notes: this.notes,
        lastUsedTimestamp: new Date()
      });

      this.$emit("created-jobsite", newJobSite);
      this.close();
    },

    checkValid(): boolean {
      if (!this.name && !this.streetAddress) return false;
      return true;
    },

    close(): void {
      this.name = "";
      this.streetAddress = "";
      this.city = "";
      this.notes = "";

      this.dialog = false;
    }
  }
});
